import { SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import noImagePlaceholder from "src/assets/no-image-placeholder.webp";
import { Skeleton } from "antd";

import { Carousel, CarouselImage } from "./ImagesCarousel.styles";

export interface ImagesCarouselProps {
  loading?: boolean;
  images: {
    id: number;
    url: string;
  }[];
}

const ImagesCarousel: React.FC<ImagesCarouselProps> = ({ loading = false, images }) => {
  return (
    <Carousel
      loop
      slidesPerView="auto"
      direction="horizontal"
      pagination={{
        clickable: true,
      }}
      navigation
      modules={[Autoplay, Pagination, Navigation]}
    >
      {loading && (
        <SwiperSlide key="loading-placeholder">
          <Skeleton.Node active />
        </SwiperSlide>
      )}

      {!loading && images.length === 0 && (
        <SwiperSlide key="no-image-placeholder">
          <CarouselImage src={noImagePlaceholder} alt={"No image provided"} />
        </SwiperSlide>
      )}

      {images.map((image) => (
        <SwiperSlide key={image.id}>
          <CarouselImage src={image.url} alt={image.url} />
        </SwiperSlide>
      ))}
    </Carousel>
  );
};

export default ImagesCarousel;
